import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function Join() {
  const { token } = useParams();
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/invites/${token}`).then((r) => setInfo(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);
  const accept = async () => {
    try { await api.post(`/invites/${token}/accept`); await refresh(); toast.success(`Welcome to ${info.household_name}!`); nav("/app"); } catch (e) { toast.error(errMsg(e)); }
  };
  const saveNext = () => localStorage.setItem("pl_next", `/join/${token}`);
  return (
    <div className="min-h-screen bg-[#FAF7F2] grid place-items-center px-5" data-testid="join-page">
      <div className="pl-card p-7 max-w-md w-full text-center space-y-4">
        <div className="flex justify-center"><Logo /></div>
        {err ? <p data-testid="join-error">{err}</p> : !info ? <p>Loading...</p> : (
          <>
            <h1 className="font-heading text-3xl font-extrabold">Join {info.household_name}</h1>
            <p className="text-slate-600">{info.invited_by} invited you to share pet care. You'll see the same live checklist.</p>
            {user ? <button className="pl-btn-primary w-full" onClick={accept} data-testid="join-accept-btn">Join household</button> : (
              <div className="grid gap-2">
                <Link to="/signup" onClick={saveNext} className="pl-btn-primary" data-testid="join-signup-btn">Create free account</Link>
                <Link to="/login" onClick={saveNext} className="pl-btn-ghost" data-testid="join-login-btn">I have an account</Link>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
